/*
 * Module for the description for the Topic Page
 */

define(["marionette", "modules/topicsSplit/topic/topicDetails/topicDetailsView"], function (
  Marionette,
  TopicDetailsView,
) {
  var TopicDetailsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicDetailsModule";
    },
    show: function (topic) {
      this.view = new TopicDetailsView.topicDetailsView({ model: topic });
      this.showRegion(this.view);
    },
  });

  return TopicDetailsController;
});
